var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buttons level-item"},_vm._l((_vm.options),function(option){return _c('button',{key:option,staticClass:"lb-button is-capitalized",class:{
            'is-primary has-text-weight-bold': option == _vm.filter,
            'is-light': option != _vm.filter,
        },on:{"click":function($event){return _vm.$emit('update:filter', option)}}},[_vm._v("\n        "+_vm._s(option)+"\n    ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }